var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "look__item",
      on: {
        click: function($event) {
          return _vm.openLookModal()
        }
      }
    },
    [
      _c("lazy-img", {
        attrs: {
          "picture-class": "",
          "image-url": _vm.image,
          alt: _vm.name,
          title: _vm.name
        }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "btn btn-primary look__btn" }, [
        _vm._v("Zum Look"),
        _vm.showLoading ? _c("span", [_vm._v(" (lädt...)")]) : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showItemModal,
              expression: "showItemModal"
            }
          ],
          ref: "quickViewModal",
          staticClass:
            "category-item__quick-view-item-modal category-item__quick-view-item-modal--looks"
        },
        [
          _c(
            "a",
            {
              staticClass: "btn-close",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.closeLookModal()
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-close",
                attrs: { "aria-hidden": "true" }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "look__item-modal-wrapper" }, [
            _c("img", {
              staticClass: "look-img",
              attrs: { src: _vm.image, alt: _vm.item.texts.name2 + " Look" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "category-item__look-rightside" }, [
              _vm.loadingItemData
                ? _c(
                    "div",
                    {
                      staticClass:
                        "category-item__look-rightside--loading-overlay"
                    },
                    [_c("span", [_vm._v("Artikel wird geladen...")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showItemModal
                ? _c(
                    "div",
                    { staticClass: "category-item__quick-view-item-image" },
                    [
                      _c("item-image-carousel", {
                        attrs: {
                          "max-quantity": 8,
                          "image-url-accessor": "urlMiddle",
                          "show-thumbs": true,
                          "show-dots": false,
                          "animation-style": "",
                          "enable-lightbox": false,
                          "plugin-path": _vm.pluginPath,
                          "thumbs-horizontal": true,
                          "category-item-data": _vm.item
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showItemModal
                ? _c("div", { staticClass: "category-item__quick-view-info" }, [
                    _c(
                      "div",
                      { staticClass: "category-item__quick-view-headline" },
                      [_vm._v(_vm._s(_vm.item.texts.name2))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "category-item__quick-view-price-wrapper"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "category-item__quick-view-price" },
                          [
                            _c("div", { staticClass: "prices" }, [
                              _vm.item.prices.rrp &&
                              _vm.item.prices.rrp.price.value > 0 &&
                              _vm.item.prices.rrp.price.value >
                                _vm.item.prices.default.unitPrice.value
                                ? _c(
                                    "div",
                                    { staticClass: "price-view-port" },
                                    [
                                      _vm.item.prices.specialOffer
                                        ? _c(
                                            "del",
                                            { staticClass: "crossprice" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.item.prices.default
                                                      .unitPrice.formatted
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "del",
                                            { staticClass: "crossprice" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.item.prices.rrp
                                                      .unitPrice.formatted
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "price" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("specialOffer")(
                                        _vm.item.prices.default.unitPrice
                                          .formatted,
                                        _vm.item.prices,
                                        "unitPrice",
                                        "formatted"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-item__quick-view-txt" },
                      [
                        _vm._v(
                          "Artikelnummer:    " +
                            _vm._s(_vm.item.variation.number)
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-item__quick-view-details" },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm._f("itemURL")(_vm.item, false),
                              title: _vm.item.texts.name2
                            }
                          },
                          [_vm._v("Artikeldetails")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.attributesMap.length
                      ? _c(
                          "div",
                          [
                            _c("variation-select-category", {
                              attrs: {
                                attributes: _vm.attributesMap,
                                variations: _vm.variationsMap,
                                "item-variations": _vm.variations,
                                "variation-id": _vm.mainvariationid,
                                "selected-variation": _vm.item
                              },
                              on: { childToParent: _vm.onChildClick }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showItemModal
                ? _c(
                    "div",
                    { staticClass: "category-item__quick-view-basket-row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "category-item__quick-view-basket-col--left"
                        },
                        [
                          _vm.attributesMap
                            ? _c("variation-select-category", {
                                attrs: {
                                  attributes: _vm.attributesMap,
                                  variations: _vm.variationsMap,
                                  "item-variations": _vm.variations,
                                  "variation-id": _vm.mainvariationid,
                                  "selected-variation": _vm.item,
                                  "is-size": true
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "category-item__quick-view-basket-col--right"
                        },
                        [
                          _c("QuantityInput", {
                            attrs: { value: _vm.qty },
                            on: { "quantity-change": _vm.updateQty }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "category-item__quick-view-basket-col--left od-wishlist"
                        },
                        [
                          _c("add-to-wish-list", {
                            attrs: { "variation-id": _vm.item.variation.id }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "category-item__quick-view-basket-col--right od-basket"
                        },
                        [
                          _vm.item
                            ? _c("add-to-basket", {
                                attrs: {
                                  "variation-id": _vm.item.variation.id,
                                  "item-id-category": _vm.item.item.id,
                                  "is-salable":
                                    !!_vm.item.filter &&
                                    _vm.item.filter.isSalable,
                                  "has-children":
                                    !!_vm.item.filter &&
                                    _vm.item.filter.hasActiveChildren,
                                  "interval-quantity":
                                    _vm.item.variation.intervalOrderQuantity ||
                                    1,
                                  "minimum-quantity":
                                    _vm.item.variation.minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.item.variation.maximumOrderQuantity &&
                                    _vm.item.variation.maximumOrderQuantity > 0
                                      ? _vm.item.variation.maximumOrderQuantity
                                      : null,
                                  "order-properties": _vm.item.properties.filter(
                                    function(prop) {
                                      return prop.property.isOderProperty
                                    }
                                  ),
                                  "has-order-properties":
                                    _vm.item.hasOrderProperties,
                                  "use-large-scale": false,
                                  "show-quantity": false,
                                  "item-url": _vm._f("itemURL")(_vm.item),
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.item
                                  ),
                                  propQuantity: _vm.qty
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "category-item__look-items" }, [
            _c("div", { staticClass: "category-item__look-items-title" }, [
              _vm._v("weitere artikel des looks")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "category-item__look-items-swiper" }, [
              _c(
                "div",
                { ref: "itemSwiper", staticClass: "swiper-container" },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-slide",
                          on: {
                            click: function($event) {
                              return _vm.loadItem()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "category-item__look-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "category-item__look-items-img-wrap"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      alt: _vm.mainItem.texts.name2,
                                      src:
                                        _vm.mainItem.images.sorted[0]
                                          .urlSecondPreview
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "category-item__look-item-name"
                                },
                                [_vm._v(_vm._s(_vm.mainItem.texts.name2))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "category-item__look-item-price"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mainItem.prices.default.unitPrice
                                        .formatted
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.initiallyUsedEntries, function(item, key) {
                        return item.data
                          ? _c(
                              "div",
                              {
                                staticClass: "swiper-slide",
                                class: "swiper-slide--" + key,
                                on: {
                                  click: function($event) {
                                    return _vm.loadItem(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "category-item__look-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "category-item__look-items-img-wrap"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            alt: item.data.texts.name2,
                                            src:
                                              item.data.images.sorted[0]
                                                .urlSecondPreview
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "category-item__look-item-name"
                                      },
                                      [_vm._v(_vm._s(item.data.texts.name2))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "category-item__look-item-price"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.data.prices.default.unitPrice
                                              .formatted
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2)
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "category-item__quick-view-txt category-item__quick-view-txt--after-price"
      },
      [
        _vm._v("    inkl. MwSt., zzgl. "),
        _c("a", { attrs: { href: "/zahlung-und-versand", title: "Versand" } }, [
          _vm._v("Versand")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category-item__thumb-swiper-prev" }, [
      _c("i", { staticClass: "icon-left" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category-item__thumb-swiper-next" }, [
      _c("i", { staticClass: "icon-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }